<template>
  <div class="lineup_cont" id="lineup">
    <h2 class="wrapper">
      <img class="pc" src="../assets/img/pc/lineup_ttl.png" alt="LINE UP">
      <img class="sp" src="../assets/img/sp/lineup_ttl.png" alt="LINE UP">
    </h2>
    <ul class="lineup_list wrapper">
      <li v-for="i in 36" :key="i">
        <div class="img_cont">
          <!-- <img src="../assets/img/lineup01@2x.png" alt=""> -->
          <img v-if="i < 10" :src="require('@/assets/img/lineup0' + i + '@2x.png')">
          <img v-else :src="require('@/assets/img/lineup' + i + '@2x.png')">
        </div>
        <!-- /.img_cont -->
        <dl>
          <dt class="no">{{ i }}</dt>
          <!-- /.no -->
          <dd class="desc" :class="products[i-1].css_desc" v-html="products[i-1].copy"></dd>
          <!-- /.desc -->
          <dd class="ttl" :class="['l' + products[i-1].ttl, products[i-1].css_ttl]">
              <span v-html="products[i-1].name"></span>
          </dd>
          <!-- /.ttl -->
          <a :href="'https://yunker.sato-cp.jp/senkyo_2020/?product=' + i" target="_blank" class="vote_btn">
          <img src="@/assets/img/vote_btn.png" alt="投票する">
          </a><!-- /.vote_btn -->
        </dl>
      </li>
    </ul>
    <!-- /.lineup_list -->
  </div>
</template>

<script>
import products from '@/assets/data_1.json'
export default {
  name: 'LineUp',
  data() {
    return {
      products: products
    }
  }
}
</script>
